import type { IconProps } from './types';

export const Home01Icon = (props: IconProps) => {
  const { color = 'currentColor', size = 24, ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path d="M22 22H2V11L12 2L22 11V22Z" stroke={color} strokeWidth="1.5" />
    </svg>
  );
};
